import { render, staticRenderFns } from "./busquedaDelPredio.vue?vue&type=template&id=32a836d9&scoped=true&"
import script from "./busquedaDelPredio.vue?vue&type=script&lang=js&"
export * from "./busquedaDelPredio.vue?vue&type=script&lang=js&"
import style0 from "./busquedaDelPredio.vue?vue&type=style&index=0&id=32a836d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a836d9",
  null
  
)

export default component.exports